module.exports = __webpack_public_path__ + "img/支付宝.f23bc555.png";